let config = {};

// 项目名称
config.projectName = 'ALL IN ONE';
// 跳转首页
// config.mainPage = "dashboard";
config.mainPage ="home";
// config.welcomePage = "wlc";
config.changePwd = "changepassword";
// layer配置
config.layer = {
	confirm: {
		top: '150px'
	},
	msg: {
		top: '100px'
	},
	load: {
		top: '200px',
	},
	msg_timeout: 5000
};

// 模块配置
config.modules = {
	sysManage: '系统管理',
	equipCtrlManage: '设备监视',
	dataManage: '后台管理',
	equipManage: '设备管理',
	checkManage: '点检管理',
    repairManage: '维修管理',
    commonBase:'通用基础',
    equipBase:'设备基础',
	// visual:'可视化',
	production:'生产管理',
	local:'现场管理',
	transaction:'事务管理',
	scbg:'生产报工',
};
config.home = {
	name: '仪表盘',
	name_en: 'home',
};
// 仪表盘
config.dashboard = {
	name: '仪表盘',
	name_en: 'edbList',
};

// 设备看板
config.equipShow = {
	name: '设备看板',
	name_en: 'equipShowList',
};


// 用户
config.user = {
	name: '用户管理',
	name_en: 'userlist',
};

// 角色
config.role = {
	name: '角色管理',
	name_en: 'rolelist',
};

// 部门
config.dept = {
	name: '部门管理',
	name_en: 'deptlist'
}

// 工厂
config.plant = {
	name: '工厂管理',
	name_en: 'plantlist'
}

// 工序
config.process = {
	name: '工序管理',
	name_en: 'processlist'
}

// 设备
config.equipment = {
	name: '设备管理',
	name_en: 'equipmentList'
}

// 设备类型
config.equipmentType = {
	name: '设备类型',
	name_en: 'equipmentTypeList'
}
// 设备部位
config.equipmentPart = {
	name: '设备部位',
	name_en: 'equipmentPartList'
}
// 周期
config.cycle = {
	name: '周期管理',
	name_en: 'cycleList'
}
// 信号灯
config.signal = {
	name: '信号灯管理',
	name_en: 'signalList'
}
// 工具
config.tool = {
	name: '工具管理',
	name_en: 'toolList'
}
// 点检项目
config.check = {
	name: '点检项目',
    name_en: 'checkList',
    checkType:'01',
    changeType:'02',
}
// 设备运维
config.equipOpt = {
	name: '设备管理',
	name_en: 'equipOptList'
}
// 点检组
config.checkGroup = {
	name: '点检组',
	name_en: 'checkGroupList'
}

// 更换项目
config.checkChange = {
	name: '更换项目',
	name_en: 'checkChangeList'
}
// 故障项目
config.trouble = {
	name: '故障项目',
	name_en: 'troubleList'
}
// 故障部位
config.equipTrouble = {
	name: '故障部位',
	name_en: 'equipTroubleList'
}

// 故障状态
config.equipTroubleStatus = {
	name: '故障状态',
	name_en: 'equipTroubleStatusList'
}

// 设备参数
config.equipParameter = {
	name: '设备参数',
	name_en: 'equipParameterList'
}

// 点检计划
config.checkPlan = {
	name: '点检计划',
	name_en: 'checkPlanList'
}

// 点检计划确认
config.planCalendar = {
	name: '点检计划确认',
	name_en: 'planCalendarList'
}

// 点检计划确认
config.checkPlanDay = {
	name: '点检计划日视图',
	name_en: 'checkPlanDayList'
}


// 系统配置
config.sysConfig = {
	name: '系统字典',
	name_en: 'configList'
}

// 系统配置
config.sysSetting = {
	name: '系统配置',
	name_en: 'sysSettingList'
}

// 维修
config.repair = {
	name: '维修管理',
	name_en: 'repairList'
}

config.repairApply = {
	name: '维修申请',
	name_en: 'repairApplyList'
}

config.repairAct = {
	name: '维修实际',
	name_en: 'repairActList'
}
// 点检计划实际
config.checkAct = {
	name: '点检计划实际',
	name_en: 'checkActList'
}
// 开工率
config.optRate = {
	name: '开工率设定',
	name_en: 'optRateList'
}

// 设备甘特图
config.equipBoard = {
	name: '设备甘特图',
	name_en: 'equipBoardList'
}

// 设备状态清单
config.equipRealStatus = {
	name: '设备状态清单',
	name_en: 'equipRealStatus'
}

// 设备图表
config.equipBar = {
	name: '设备KPI',
    name_en: 'equipBar',
}

// 设备图表
config.equipReport = {
	name: '设备报表',
	name_en: 'equipReport'
}
/*
可视化管理模块
 */
// 计划分解
config.planSplit = {
	name: '计划分解',
	name_en: 'planSplit'
}

// 计划调整
config.planAdjust = {
	name: '计划调整',
	name_en: 'planAdjust'
}

// 进度查询
config.progressQueryList = {
	name: '进度查询',
	name_en: 'progressQueryList'
}
//机台实绩一览
config.realityList = {
	name: '机台实绩一览',
	name_en: 'realityList'
}

// 机台列表
config.workList = {
	name: '机台列表',
	name_en: 'workList'
}

// 实绩登录
config.actualLoginList = {
	name: '实绩登录',
	name_en: 'actualLoginList'
}
// 看板
config.spectacularsList = {
	name: '现场看板',
	name_en: 'spectacularsList'
}

// 暂停维护
config.pauser = {
	name: '暂停维护',
	name_en: 'pauserList'
}
// 不良履历
config.dfhistory = {
	name: '不良履历',
	name_en: 'dfhistoryList'
}


// KPI详细
config.kpiDetail = {
	name: 'KPI详细',
    name_en: 'kpiDetail',
    sortType:[
        {key:'NORMAL_TIME',title:'运行',code:'01'},
        {key:'DEBUG_TIME',title:'调试',code:'02'},
        {key:'REPAIR_TIME',title:'故障',code:'03'},
        {key:'ELECTRIFY_TIME',title:'通电',code:'04'},
        {key:'DOWN_TIME',title:'停机',code:'05'},
        {key:'USE_PERCENT',title:'开工率',code:'usePercent'},
    ],
}
// 分页参数
config.pageParams = {
	total: 0,
	opts: [10, 20, 50, 100],
	currentPage: 1,
	pageSize: 10,
	pageLayout: 'total, prev, pager, next, sizes,jumper'
};

// 查询参数
config.queryParam = {
	pageNum: 0,
	pageSize: 10
};

config.listAllPageParams = {
	pageNum: 0,
	pageSize: 9999
};
// cookies
config.cookies = {
	token: 'slash_token',
	currRoleId: 'currRoleId',
	currPlantId: 'currPlantId',
	currUser: 'currUser',
	skinColor:'skinColor'
};

// cfgType
config.cfgType = {
	status: '001',
	//工厂-经营属性
	plantType: '002',
	//设备-计算类型
	equipCalcType: '003',
	//开关状态
	oNOffType: '027',
	//警灯显示项目
	monitorType: '005',
	//是否分类
	tfType: '007',
	//工具类型
	toolType: '006',
	groupType: '008',
	// 点检状态
	checkStatus: '009',
	// 点检类型
	checkType: '010',
	// 日期输入类型
	inputDateType: '012',
	// 点检计划类型
	checkPlanType: '015',
	// 重复类型
	checkCycleType: '016',
	// 月计划类型
	monthStandType: '017',
	// 推迟类型
	freeDayType: '018',
	// 通知类型
	notifyType: '019',
	// 提前通知类型
    aheadNotifyType: '020',
    // 申请类型
    applyType:'022',
    // 优先级
    priLevel:'023',
    // 有无库存
    fittingHave:'021',
    // 运行状态
    statusType:'026',
};

config.onOffTypeArr = [
    {codeVal:'0',codeName:'0',},
    {codeVal:'1',codeName:'1',},
    {codeVal:'2',codeName:'2',},
    {codeVal:'9',codeName:'9',},
];

// list列表配置
config.list = {
	// 排序
	sortKey: 'lastModifiedWhen',
	sortValue: 'desc'
};

config.Reg = {
	intVal: /^[0-9]+$/,
    number: /^([1-9]\d*|0)(\.\d{1,10})?$/,
};

config.msg = {
    // 操作对象校验
    selectOne :'只能选择一个对象操作！',
    selectNeed : '请选择需要操作的对象！'
};

// 信号灯颜色
config.signalColor = {
    // '00':{
    //     title:'默认',
    //     color:'white',//385723
    // },//正常运行
    '01':{
        title:'运行',
        color:'#4caf50',//385723
    },//正常运行
    '02':{
        title:'调试',
        color:'#ec7f34',//ED7D31
    },//调试
    '03':{
        title:'故障',
        color:'#FF0000',
    },//故障
    '04':{
        title:'通电',
        color:'#0070C0',
    },//通电
    '05':{
        title:'停机',
        color:'#9e9e9e',
    },//停机
};


config.runStatusList = [
    {code:'01',name:'运行'},
    {code:'02',name:'调试'},
    {code:'03',name:'故障'},
    {code:'04',name:'通电'},
    {code:'05',name:'停机'},
];

config.runStatusEnObj = {
    '01':'normalTime',
    '02':'debugTime',
    '03':'repairTime',
    '04':'electrifyTime',
    '05':'downTime',
};

// 点检计划状态颜色
config.planStatusColor = {
    '01':'#199ed8',//未检查
    '02':'#009966', //已检查
    '03':'#ff0000', //已过期未检查
    '04': '#ff9900', //中止
    '05':'#bcbcbc', // 检查中
};

// 开工率公式配置
config.optRateParam = {
    normalTime:'运行时间',
    debugTime:'调试时间',
    downTime:'停机时间',
    electrifyTime:'通电时间',
    repairTime:'故障时间',
};

//生产计划
config.vPowderPlanDetail= {
	name:'生产计划',
	name_en:'vPowderPlanDetailList'
};

//Weekly Delivery Plan
config.vDeliveryPlanW= {
	name:'周间出荷',
	name_en:'vDeliveryPlanW'
};

//出货分配一览
config.vDeliveryPlanWa= {
	name:'出货分配一览',
	name_en:'vDeliveryPlanWa'
};

//螺杆尺寸维护
config.tGradeRoller= {
	name:'螺杆尺寸维护',
	name_en:'tGradeRoller'
};
//产线管理
config.mEquipmentLine= {
	name:'产线管理',
	name_en:'mEquipmentLine'
};
//粉分配状态
config.vPowderStatus= {
	name:'粉分配状态',
	name_en:'vPowderStatus'
};
//Grade Group
config.tGradeGroup= {
	name:'Grade Group',
	name_en:'tGradeGroup'
};
//报工类别
config.tWebProdAll= {
	name:'报工类别',
	name_en:'stWebProdAllList'
};

//报工一览
config.vStWebProdAll= {
	name:'报工一览',
	name_en:'vStWebProdAllList'
};
//config/config.js
//客户码头对应信息
config.mCustomerYard= {
	name:'客户码头对应信息',
	name_en:'mCustomerYard'
};
//客户基础信息
config.mCustomer= {
	name:'客户基础信息',
	name_en:'mCustomer'
};
//config/config.js
//产线主表维护
config.mPlantLine= {
	name:'产线主表维护',
	name_en:'mPlantLine'
};
//客户品目对应信息
config.mCustomerGrade= {
	name:'客户品目对应信息',
	name_en:'mCustomerGrade'
};
//品目库存月度安全系数维护
config.mStockSafeRatio= {
	name:'品目库存月度安全系数维护',
	name_en:'mStockSafeRatio'
};
//排程规则
config.mGradeRule= {
	name:'排程规则',
	name_en:'mGradeRule'
};
//盘点库存
config.tTanaStock= {
	name:'盘点库存',
	name_en:'tTanaStock'
};
//销售订单
config.vSalesOrder= {
	name:'销售订单',
	name_en:'vSalesOrder'
};
export default config;



// WEBPACK FOOTER //
// ./src/config/config.js